export default () => ({
  trigger: {
    name: 'configurator.show_usage_situations',
    params: {},
  },
  config: {
    event: {
      name: 'show_content',
      params: {
        sub_feature: 'usage_situations',
      },
    },
    nonInt: true,
  },
});
